import styled from 'styled-components'

export const Pulse = styled.circle`
    animation: pulse 1800ms infinite ease;

    @keyframes pulse {
        0%,
        100% {
            opacity: 0.15;
            transform: scale(1);
        }
        50% {
            opacity: 0.2;
            transform: scale(1.5);
        }
    }
`
export const TopEventCircle = styled.circle``

export const MiddlePulseContentContainer = styled.div`
    .topEventTitle {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        line-height: normal;
        vertical-align: middle;
        overflow: hidden;
        min-height: 48px;
        color: #000;
    }
    .bowtieStatus {
        overflow: auto;
        margin-top: 8px;
        display: -webkit-box;
        -webkit-box-orient: horizontal;
        -webkit-line-clamp: 1;
        text-align: center;
        font-weight: bold;
        justify-content: center;
        font-size: 12px;

        svg {
            margin-left: 8px;
        }
    }
    .alarp {
        display: -webkit-box;
        -webkit-box-orient: horizontal;
        -webkit-line-clamp: 1;
        text-align: center;
        font-size: 11px;
        font-weight: 400;
        justify-content: center;
    }
`
